import React from 'react';

import { WEB_VISOR_DISABLE, WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { FormatUtils } from 'app/utils/FormatUtils';

export type CommaSeparatedListItem = {
    /**
     * Начало строки (Может представлять как значащую часть, так и вспомогательную)
     */
    prefix?: string;

    /**
     * Окончание строки (Может представлять как значащую часть, так и вспомогательную)
     */
    postfix?: string;

    /**
     * Определяет какая часть является значащей
     *
     * true: значащая часть - postfix
     * false: значащая часть - prefix
     */
    reordered?: boolean;
};

export interface CommaSeparatedListProps {
    values: Array<CommaSeparatedListItem>;
}

/**
 * Предаставления списка {@link CommaSeparatedListItem} в виде строки, через запятую.
 * Не включает элемент в списка в итоговую строку, в случае если значащая часть отсутствует.
 *
 * @param values
 * @constructor
 */
export const CommaSeparatedList = ({ values }: CommaSeparatedListProps) => {
    const filteredValues = values.filter((value) => {
        return (
            (!!value.prefix && !value.reordered) ||
            (value.reordered && !!value.postfix)
        );
    });

    const mappedValues = filteredValues.map((value) => {
        const elPrefix = value.prefix ? (
            <span className="prefix">
                {FormatUtils.toAddressString(value.prefix)}
            </span>
        ) : null;

        const elPostfix = !!value.postfix ? (
            <span className="postfix">
                {FormatUtils.toAddressString(value.postfix)}
            </span>
        ) : null;

        return value.reordered ? (
            <span>
                {elPostfix}
                {elPrefix ? ' ' : ''}
                {elPrefix}
            </span>
        ) : (
            <span>
                {elPrefix}
                {elPostfix ? ' ' : ''}
                {elPostfix}
            </span>
        );
    });

    return (
        <span>
            {mappedValues.map((element, index) => {
                const key =
                    filteredValues[index].prefix +
                    filteredValues[index].postfix;

                return (
                    <span key={key} className={WEB_VISOR_HIDE}>
                        {element}
                        {index < mappedValues.length - 1 ? ', ' : ''}
                    </span>
                );
            })}
        </span>
    );
};
